import { useMemo, useRef } from "react";

// The If-Match a locked save echoes (useTargetsDoc, the program editor). A
// ref: the save reads it at call time. A write validator, never a 304 one.
export type EtagValidator = {
  /** The validator in hand, or null. */
  current: () => string | null;
  /** Arms it from an answer's `ETag`; null when the answer had none. */
  onEtag: (etag: string | null) => void;
  /** Drops it: the server's version moved without this client reading it. */
  clear: () => void;
};

export function useEtagValidator(): EtagValidator {
  const ref = useRef<string | null>(null);
  return useMemo(
    () => ({
      current: () => ref.current,
      onEtag: (etag) => {
        ref.current = etag;
      },
      clear: () => {
        ref.current = null;
      },
    }),
    [],
  );
}
